import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { t } from "i18next";

const CustomDialog = ({
  title,
  body,
  textClose = t("common.cancel"),
  textCallToAction = t("common.confirm"),
  callback,
  trigger,
}) => {
  const modalRef = useRef(null);
  const [show, setShow] = useState(false);

  const handleShow = (e) => {
    e?.stopPropagation(); // Impedisce la propagazione solo quando necessario
    setShow(true);
  };

  const handleClose = () => {
    setShow(false); // Non c'è bisogno di passare l'evento
  };

  const handleConfirm = (e) => {
    e.stopPropagation(); // Stop della propagazione per il click sul pulsante
    if (callback) callback();
    handleClose(); // Chiamata senza passare `e`
  };

  return (
    <>
      {trigger ? (
        React.cloneElement(trigger, { onClick: handleShow })
      ) : (
        <Button variant="primary" onClick={handleShow}>
          Apri Dialog
        </Button>
      )}

      <Modal
        show={show}
        onHide={handleClose} // Rimuoviamo l'evento da qui
        ref={modalRef}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation(); // Stop della propagazione per il pulsante di chiusura
              handleClose();
            }}
          >
            {textClose}
          </Button>
          <Button
            variant="success"
            onClick={handleConfirm} // Invia direttamente la funzione senza passare `e` altrimenti
          >
            {textCallToAction}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomDialog;
